import { ClerkProvider as BaseClerkProvider } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

interface ClerkProviderProps {
  children: React.ReactNode;
}

export const ClerkProvider: React.FC<ClerkProviderProps> = ({ children }) => {
  const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY!;

  return (
    <BaseClerkProvider
      publishableKey={publishableKey}
      signInUrl={process.env.REACT_APP_CLERK_SIGN_IN_URL}
      signUpUrl={process.env.REACT_APP_CLERK_SIGN_UP_URL}
      afterSignInUrl={process.env.REACT_APP_CLERK_AFTER_SIGN_IN_URL}
      afterSignUpUrl={process.env.REACT_APP_CLERK_AFTER_SIGN_UP_URL}
    >
      {children}
    </BaseClerkProvider>
  );
};
